import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 21.75 21.75"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M15.71 1.09a.87.87 0 0 0-.69-.05c-.23.08-.42.24-.52.45-.11.22-.12.46-.05.69s.24.41.45.52c3.15 1.58 5.04 4.63 5.04 8.16 0 2.44-.94 4.72-2.64 6.42s-3.99 2.64-6.42 2.64-4.72-.94-6.42-2.64-2.64-3.99-2.64-6.42C1.81 6.17 5.31 2.3 9.97 1.85v9.92L8.2 10c-.36-.36-.94-.36-1.3 0s-.36.94 0 1.3l3.32 3.32a.915.915 0 0 0 1.3 0l3.32-3.32a.915.915 0 0 0 0-1.3.936.936 0 0 0-1.3 0l-1.77 1.77V.9c0-.5-.41-.9-.9-.9-2.92 0-5.65 1.13-7.7 3.17C1.13 5.22 0 7.95 0 10.87s1.13 5.66 3.17 7.7 4.78 3.17 7.7 3.17 5.66-1.13 7.7-3.17 3.17-4.78 3.17-7.7c0-4.17-2.31-7.92-6.04-9.78Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }